import React from "react";

/**
 * Rotating gold seal - editorial award badge.
 * Outer ring has rotating text ("BEST BURGER STUTTGART 2026").
 * Inner shows #1 + BUDDIEZ.
 */
export default function AwardSeal({ size = 160, className = "" }) {
  const id = "seal-path";
  const r = size / 2;
  const textRadius = r - 12;
  return (
    <div
      className={`relative inline-flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      data-testid="award-seal"
      aria-label="Stuttgart Burger Test 2026 - Platz 1"
    >
      <svg
        viewBox={`0 0 ${size} ${size}`}
        width={size}
        height={size}
        className="seal-rotate absolute inset-0"
      >
        <defs>
          <path
            id={id}
            d={`M ${r},${r} m -${textRadius},0 a ${textRadius},${textRadius} 0 1,1 ${textRadius * 2},0 a ${textRadius},${textRadius} 0 1,1 -${textRadius * 2},0`}
            fill="none"
          />
        </defs>
        <circle cx={r} cy={r} r={r - 1} fill="none" stroke="#E8B14A" strokeWidth="1" opacity="0.5" />
        <circle cx={r} cy={r} r={r - 18} fill="none" stroke="#E8B14A" strokeWidth="1" opacity="0.35" />
        <text
          fill="#E8B14A"
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: Math.max(9, size * 0.075),
            letterSpacing: "0.35em",
            textTransform: "uppercase",
          }}
        >
          <textPath href={`#${id}`} startOffset="0">
            STUTTGART BURGER TEST 2026 · PLATZ 1 · STUTTGART BURGER TEST 2026 · PLATZ 1 ·
          </textPath>
        </text>
      </svg>
      <div className="relative flex flex-col items-center justify-center">
        <div className="font-editorial text-[#E8B14A] leading-none" style={{ fontSize: size * 0.32 }}>
          №1
        </div>
        <div
          className="font-mono-accent uppercase text-[#E8B14A]/80 mt-1"
          style={{ fontSize: Math.max(8, size * 0.055), letterSpacing: "0.25em" }}
        >
          BUDDIEZ
        </div>
      </div>
    </div>
  );
}
